import * as yup from 'yup';

export const LcQuadrilSchema = yup.object().shape({
  num_registro_quadril: yup
    .number()
    .typeError('Campo obrigatório. Máximo 5 dígitos.')
    .required('Campo obrigatório'),
  sexo_quadril: yup.string().nullable(true),
  dn_quadril: yup.string().nullable(true),
  convenio_quadril: yup.string().nullable(true),

  // Dados da doença e tratamento
  iam_quadril: yup.string().nullable(true),
  ic_quadril: yup.string().nullable(true),
  dvp_quadril: yup.string().nullable(true),
  avc_ait_quadril: yup.string().nullable(true),
  demencia_quadril: yup.string().nullable(true),
  dpoc_quadril: yup.string().nullable(true),
  dtc_quadril: yup.string().nullable(true),
  hepatica_quadril: yup.string().nullable(true),
  dm_quadril: yup.string().nullable(true),
  drc_quadril: yup.string().nullable(true),
  tumor_quadril: yup.string().nullable(true),
  leucemia_quadril: yup.string().nullable(true),
  linfoma_quadril: yup.string().nullable(true),
  aids_quadril: yup.string().nullable(true),
  hoos_quadril: yup.string().nullable(true),
  dependencia_quadril: yup.string().nullable(true),
  meem_quadril: yup.string().nullable(true),
  escolaridade_quadril: yup.string().nullable(true),
  internacao_quadril: yup.string().nullable(true),
  politrauma_quadril: yup.string().nullable(true),
  entrada_data_quadril: yup.string().nullable(true),
  entrada_hora_quadril: yup.string().nullable(true),
  admissao_data_quadril: yup.string().nullable(true),
  admissao_hora_quadril: yup.string().nullable(true),
  antibiotico_data_quadril: yup.string().nullable(true),
  antibiotico_hora_quadril: yup.string().nullable(true),
  incisao_data_quadril: yup.string().nullable(true),
  incisao_hora_quadril: yup.string().nullable(true),
  profilaxia_tv_quadril: yup.string().nullable(true),
  anticoagulacao_quadril: yup.string().nullable(true),
  dor_quadril: yup.string().nullable(true),
  sentar_data_quadril: yup.string().nullable(true),
  sentar_hora_quadril: yup.string().nullable(true),
  deambular_data_quadril: yup.string().nullable(true),
  deambular_hora_quadril: yup.string().nullable(true),

  // Dados da saída
  covid_quadril: yup.string().nullable(true),
  saida_motivo_quadril: yup.string().nullable(true),
  saida_data_quadril: yup.string().nullable(true),
  saida_hora_quadril: yup.string().nullable(true),

  // Seguimento
  paliativo_quadril: yup.string().nullable(true),
  reinternacao_quadril: yup.string().nullable(true),
  reinternacao_motivo_quadril: yup.string().nullable(true),
  infeccao_quadril: yup.string().nullable(true),
  infeccao_data_quadril: yup.string().nullable(true),
  obito_seg_quadril: yup.string().nullable(true),
});
